import PropTypes from 'prop-types';

export const CustomPropType = {
  props: PropTypes.any
};

export const CustomAutocompletePropTypes = {
  fieldName: PropTypes.any,
  fieldOptions: PropTypes.any,
  onSelectValue: PropTypes.any,
};

export const CustomTooltipPropTypes = {
  children: PropTypes.any,
  content: PropTypes.any,
  backgroundColor: PropTypes.any,
  html: PropTypes.bool,
  placement: PropTypes.string
};

export const CustomDatePicker = {
  onDateChange: PropTypes.any,
  minDate: PropTypes.any,
  isDisabled: PropTypes.any,
};

export const ClientDetails = {
  show: PropTypes.any,
  clientData: PropTypes.any,
  close: PropTypes.any,
};

export const TablePropTypes = {
  headers: PropTypes.any,
  data: PropTypes.any,
  pageNo: PropTypes.any,
  tableInfo: PropTypes.any,
  size: PropTypes.any,
  total: PropTypes.any,
  showActions: PropTypes.bool,
};

export const InputDialogPropTypes = {
  show: PropTypes.any,
  data: PropTypes.any,
  close: PropTypes.any,
};

export const SessionNotesPropTypes = {
  show: PropTypes.any,
  data: PropTypes.any,
  sessionEvent: PropTypes.any,
  close: PropTypes.any,
  additionalInfo: PropTypes.any
};

export const CalendarDialogPropTypes = {
  show: PropTypes.any,
  getDate: PropTypes.any,
  closeDailog: PropTypes.any,
};

export const RatingDialogPropTypes = {
  show: PropTypes.any,
  onClose: PropTypes.any,
  onSubmit: PropTypes.any,
  name: PropTypes.any,
  id: PropTypes.any,
  image: PropTypes.any,
  method: PropTypes.any,
};

export const ConfirmDailogPropTypes = {
  message: PropTypes.any,
  show: PropTypes.any,
  handleClose: PropTypes.any,
  title: PropTypes.any,
  additionalInfo: PropTypes.any
};

export const FooterPropTypes = {
  isOpen: PropTypes.any,
};

export const SidebarPropTypes = {
  isOpen: PropTypes.any,
  toggleSidebar: PropTypes.any,
  isMobileView: PropTypes.any,
};

export const ProfileInfoPropTypes = {
  user: PropTypes.any,
};

export const BookingModalPropTypes = {
  timeSlot: PropTypes.any,
  show: PropTypes.any,
  onClose: PropTypes.any,
  onSubmit: PropTypes.any
};

export const AuthContextProviderPropTypes = {
  children: PropTypes.any,
};

export const CalendarHeaderPropTypes = {
  currentDate: PropTypes.any,
  onTherapistChange: PropTypes.any
};

export const TimeSlotCellPropTypes = {
  currentDate: PropTypes.any,
  timeSlot: PropTypes.any,
  onClick: PropTypes.any,
};

export const DateSlotPropTypes = {
  show: PropTypes.any,
  id: PropTypes.any,
  handleClose: PropTypes.any,
  reschedule: PropTypes.any,
  eventId: PropTypes.any,
  bookingDetails: PropTypes.any,
  therapist_id: PropTypes.any
};

export const CancelSessionPropTypes = {
  show: PropTypes.any,
  data: PropTypes.any,
  handleClose: PropTypes.any,
  title: PropTypes.any,
  additionalInfo: PropTypes.any
};

export const ViewSessionPropTypes = {
  show: PropTypes.any,
  data: PropTypes.any,
  handleClose: PropTypes.any,
  therapistName: PropTypes.any,
  id: PropTypes.any
};

export const ErrorHeadingPropTypes = {
  code: PropTypes.any,
  title: PropTypes.any,
  description: PropTypes.any,
};

export const ExpertisePropTypes = {
  expertise: PropTypes.any,
};

export const QualificationsPropTypes = {
  qualifications: PropTypes.any,
};
